<template>
  <b-row>
    <b-col />

    <!-- FORM WIZARD -->
    <b-col cols="10">
      <b-overlay
        v-if="!error_page"
        :show="loader.formulario"
        opacity="0.50"
        rounded="sm"
      >
        <div>
          <!-- NÚMERO DE SOLICITUD -->
          <div class="text-right">
            <b-badge
              variant="primary"
              class="badge-glow"
            >
              <p
                class="m-0"
                style="font-size: 1rem"
              >
                Solicitud No. {{ formulario.preregistro }}
              </p>
            </b-badge>
          </div>
          <br>
          <div class="text-justify">
            <p class="m-0"><small>
              Por seguridad, este formulario caduca en 30 minutos, porfavor, le pedimos complete los campos durante este intervalo de tiempo.
            </small></p>
            <p><small>
              Si el formulario se caduca, no se preocupe, vuelva a presionar el enlace que se encuentra en su correo electrónico.
            </small></p>
            <p>Tus datos personales están protegidos.
              Te invitamos a leer nuestro
              <b-button
                v-b-modal.modal-aviso
                variant="outline"
                pill
              >
                <b>Aviso de Privacidad Integral</b>
              </b-button>
              <!-- basic modal -->
              <b-modal
                id="modal-aviso"
                ref="modal-avisoprivacidad"
                scrollable
                title="AVISO DE PRIVACIDAD INTEGRAL - INDETEC "
                size="lg"
                ok-only
                ok-title="Aceptar"
                button-size="sm"
              >
                <avisoprivacidad />
              </b-modal>
            </p>
          </div>

          <form-wizard
            color="#aa9d6b"
            :title="null"
            :subtitle="null"
            finish-button-text="Terminar"
            back-button-text="Anterior"
            next-button-text="Siguiente"
            class="steps-transparent mb-3"
            @on-complete="openConfirmFunction"
          >

            <!-- TAB DATOS PERSONALES -->
            <tab-content
              title="Datos personales"
              icon="feather icon-user"
              :before-change="validationDatosPersonales"
            >
              <!-- TITLE TAB -->
              <b-row>
                <b-col
                  cols="12"
                  class="mb-1 text-center"
                >
                  <h4 class="mb-0">
                    Datos personales
                  </h4>
                  <small class="text-muted">
                    Ingresa los datos <b>mínimos obligatorios</b> para poder continuar
                  </small>
                </b-col>
              </b-row>

              <!-- VALIDACIÓN DE FORMULARIO DE DATOS PERSONALES -->
              <validation-observer ref="datosPersonales">
                <stepDatosPersonales
                  ref="datosPersonalesForm"
                  :persona="formulario.persona"
                />
              </validation-observer>
            </tab-content>

            <!-- TAB DATOS DE OCUPACIÓN -->
            <tab-content
              title="Ocupación"
              icon="feather icon-briefcase"
              :before-change="validationDatosOcupacion"
            >
              <!-- TITLE TAB -->
              <b-row>
                <b-col
                  cols="12"
                  class="mb-1 text-center"
                >
                  <h4 class="mb-0">
                    Datos de ocupación
                  </h4>
                  <small class="text-muted">
                    Ingresa los datos <b>mínimos obligatorios</b> para poder continuar
                  </small>
                </b-col>
              </b-row>

              <!-- VALIDACIÓN DE FORMULARIO DE DATOS DE OCUPACIÓN -->
              <validation-observer ref="datosOcupacion">
                <stepDatosOcupacion
                  ref="datosOcupacionForm"
                  :dependencia_cargada="formulario.dependencia"
                  :entidad_fed="formulario.entidadFederativa"
                  :departamentos="departamentos"
                  :puestos="puestos"
                />
              </validation-observer>
            </tab-content>

            <!-- TAB DATOS ACADÉMICOS -->
            <tab-content
              title="Académica"
              icon="feather icon-book-open"
              :before-change="validationDatosAcademicos"
            >
              <!-- TITLE TAB -->
              <b-row>
                <b-col
                  cols="12"
                  class="mb-1 text-center"
                >
                  <h4 class="mb-0">
                    Información académica
                  </h4>
                  <small class="text-muted">
                    Ingresa los datos <b>mínimos obligatorios</b> para poder continuar
                  </small>
                </b-col>
              </b-row>

              <!-- VALIDACIÓN DE FORMULARIO DE DATOS ACADÉMICOS -->
              <validation-observer ref="datosAcademicos">
                <stepDatosAcademicos
                  ref="datosAcademicosForm"
                  :plan-estudios-cargado="plan_estudios"
                  :nivel_educativo="grados"
                  :tipo_admision="admision"
                  :ciclo_admision="ciclo"
                />
              </validation-observer>
            </tab-content>

            <!-- TAB VERIFICACIÓN DE DATOS -->
            <tab-content
              title="Verifica tus datos"
              icon="feather icon-check-circle"
            >
              <!-- TITLE TAB -->
              <b-row>
                <b-col
                  cols="12"
                  class="mb-0 text-center"
                >
                  <h4 class="mb-1">
                    Información del solicitante
                  </h4>
                  <b-alert
                    variant="danger"
                    show
                  >
                    <div class="alert-body">
                      <span>Antes de continuar, verifique que su información sea la
                        correcta, posteriormente presione el botón <b>Terminar</b></span>
                    </div>
                  </b-alert>
                </b-col>
              </b-row>

              <!-- VALIDACIÓN DE FORMULARIO DE DATOS ACADÉMICOS -->
              <stepVerificaDatos :data="formulario" />
            </tab-content>
          </form-wizard>

        </div>
      </b-overlay>
      <b-alert
        v-else
        show
        variant="danger"
      >
        <h4 class="alert-heading">
          Algo ha ocurrido
        </h4>
        <div class="alert-body">
          <span>
            Por favor,<br> <b> - Verifique que la liga del correo de confirmación coincida con la ingresada en el navegador.</b><br> - También puede que ya haya realizado este paso. Si es asi<b> revise su bandeja de entrada (o spam) de su correo</b>. <br> - Si el error continúa pónganse en contacto con nosotros.
          </span>
        </div>
      </b-alert>
    </b-col>
    <b-col />
  </b-row>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BAlert,
  BBadge,
  BOverlay,
  BButton,
} from 'bootstrap-vue'
import { getTblNla, getData, postData } from '@core/utils/http/general'
import { rolesActions } from '@core/mixins/account-data/roles'
import avisoprivacidad from '@core/layouts/components/footer/avisoprivacidad.vue'
import stepDatosPersonales from './components/formulario/step-datosPersonales.vue'
import stepDatosOcupacion from './components/formulario/step-datosOcupacion.vue'
import stepDatosAcademicos from './components/formulario/step-datosAcademicos.vue'
import stepVerificaDatos from './components/formulario/step-verificaDatos.vue'

let interval // INTERVALO PARA HACER REDIRECT DESPUÉS DE 45MIN SIN HACER SUBMIT

export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BBadge,
    BAlert,
    BOverlay,
    BButton,
    ValidationObserver,
    stepDatosPersonales,
    stepDatosOcupacion,
    stepDatosAcademicos,
    stepVerificaDatos,
    avisoprivacidad,
  },
  mixins: [rolesActions],
  data() {
    return {
      formulario: {
        preregistro: '',
        persona: {},
        dependencia: {},
        ocupacion: {},
        entidadFederativa: {},
        academico: {},
        direccion: {},
      },
      plan_estudios: {},
      especialidad: {},
      // CATÁLOGOS
      departamentos: [],
      puestos: [],
      grados: [],
      admision: [],
      ciclo: [],
      neededFiles: [],
      // EXTRA
      counter: 1,
      tbl: '',
      old_tbl: '',
      nla: '',
      loader: { formulario: false },
      error_page: false,
      procede: true,
    }
  },
  watch: {
    plan_estudios(val) {
      this.formulario.plan = val.nombre
    },
  },
  created() {
    if (this.$route.params.id && this.$route.params.time) {
      this.loader.formulario = true

      const promesa = new Promise((resolve, reject) => {
        this.get_tbl_nla(resolve, reject)
      })
      const promesa2 = new Promise((resolve, reject) => {
        this.get_data_registered(resolve, reject)
      })
      const promesa3 = new Promise((resolve, reject) => {
        this.validacion_persona(resolve, reject)
      })

      Promise.all([promesa, promesa2, promesa3])
        .then(() => {
          this.loader.formulario = false
          this.old_tbl = this.tbl
          this.intervalRedirect()
          this.get_tipo_admision()
          this.get_ciclo_admision()
          this.get_departamentos()
          this.get_puestos()
          this.get_grados()
          this.get_available_files()
          this.loader.formulario = false
        })
        .catch(error => {
          this.error_page = true
          this.loader.formulario = false
          this.$bvToast.toast(error, {
            title: 'Error en solicitud [tbl/nla | data registered]',
            variant: 'danger',
            solid: true,
          })
        })
    } else this.error_page = true
  },
  methods: {
    validationDatosPersonales() {
      return new Promise((resolve, reject) => {
        this.$refs.datosPersonales.validate().then(success => {
          if (success) {
            this.formulario.direccion = this.$refs.datosPersonalesForm.direccion
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationDatosOcupacion() {
      return new Promise((resolve, reject) => {
        this.$refs.datosOcupacion.validate().then(success => {
          if (success) {
            this.formulario.ocupacion = this.$refs.datosOcupacionForm.ocupacion
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationDatosAcademicos() {
      return new Promise((resolve, reject) => {
        this.$refs.datosAcademicos.validate().then(success => {
          if (success) {
            this.formulario.academico = this.$refs.datosAcademicosForm.academico
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    openConfirmFunction() {
      if (this.counter <= 10) {
        this.$swal({
          title: '¿Estás seguro de querer continuar?',
          html: "<p>Una vez registrados tus datos, <b class='text-primary'>enviaremos un correo de confirmación</b>, porfavor sigue los pasos mencionados en el mismo.</p>",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Continuar',
          cancelButtonText: 'Cancelar',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            this.submitForm()
          }
        })
      } else {
        this.$bvToast.toast('Ha superado la cantidad de intentos disponibles, por favor, intente nuevamente más tarde', {
          title: 'Exceso de intentos',
          variant: 'danger',
          solid: true,
        })
      }
    },
    submitForm() {
      if (this.counter <= 10) {
        this.loader.formulario = true
        this.counter += 1
        this.formulario.id_pre = this.$route.params.id
        this.formulario.time_pre = this.$route.params.time

        const params = new FormData()
        params.append('task', 'wspublico')
        params.append('origin', process.env.VUE_APP_ORIGIN_API)
        params.append('action', 12)
        params.append('tbl', this.tbl)
        params.append('nla', this.nla)
        params.append('data', JSON.stringify(this.formulario))
        if (this.userRol.id === 2) params.append('rol', 2)

        postData(params)
          .then(response => {
            if (response.status === 200 && response.data.status === 200) {
              const { rdocs = null } = response.data
              this.registroExitoso({ rdocs })
            } else {
              this.$bvToast.toast(response.data.message, {
                title: `${response.data.status} - Error registrando datos`,
                variant: 'danger',
                solid: true,
              })

              this.tbl = response.data.tbl
            }

            this.loader.formulario = false
          })
          .catch(err => {
            this.loader.formulario = false
            this.$bvToast.toast(err, {
              title: 'Error en solicitud [registro de datos]',
              variant: 'danger',
              solid: true,
            })
          })
      } else {
        this.$bvToast.toast('Ha superado la cantidad de intentos disponibles, por favor, intente nuevamente más tarde', {
          title: 'Exceso de intentos',
          variant: 'danger',
          solid: true,
        })
      }
    },
    registroExitoso({ rdocs }) {
      this.$swal({
        title: '<b>Registro exitoso</b>',
        html: 'Estamos <b class="text-primary">validando tus datos</b>, así mismo hemos enviado un correo de confirmación.<br><br>Por favor, <b>no cierre esta ventana</b>.',
        icon: 'success',
        showConfirmButton: true,
        buttonsStyling: false,
        confirmButtonText: 'De acuerdo, continuar con el proceso.',
        allowOutsideClick: false,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      }).then(() => {
        if (rdocs === 0) this.aviso()
        else this.documentosRequeridos()
      })
    },
    documentosRequeridos() {
      const names = this.neededFiles.length ? this.neededFiles.map(({ nombre }) => nombre) : []
      const files = `<ul class="text-left"><li>${names.join('</li><li>')}</li></ul>`

      this.$swal({
        title: 'Documentos obligatorios',
        html: `${this.neededFiles.length ? files : ''}<p class="text-justify">Estos documentos son obligatorios para el proceso de aprobación a ${this.formulario.plan}.<br>Al continuar será redireccionado al <b>módulo de carga</b>, en caso de no tener los documentos a la mano, en dicho módulo, seleccione la opción de <b>"Cargar en otro momento"</b> y a su correo enviaremos una liga donde podrá cargarlos posteriormente.</p>`,
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'Continuar',
        allowOutsideClick: false,
        width: '50em',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-warning ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$router.push(`/registro/documentacion/${this.$route.params.id}/${this.$route.params.time}`)
        }
      })
    },
    aviso() {
      this.$swal({
        title: 'Aviso',
        html: '<p class="text-justify">Pronto nos contactaremos contigo para informarte sobre el estatus de tu registro. Es todo por ahora, te redirigiremos a la página principal.</p>',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'Gracias por tu registro',
        allowOutsideClick: false,
        width: '50em',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-warning ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$router.push('/oferta-academica')
        }
      })
    },
    promise_tbl_nla() {
      const vm = this

      const promesa = new Promise((resolve, reject) => {
        this.get_tbl_nla(resolve, reject)
      })

      promesa
        .then(() => {
          vm.old_tbl = vm.tbl
          vm.intervalRedirect()
        })
        .catch(error => {
          this.$bvToast.toast(error, {
            title: 'Error en solicitud [tbl/nla]',
            variant: 'danger',
            solid: true,
          })
        })
    },
    get_tbl_nla(resolve, reject) {
      getTblNla()
        .then(response => {
          if (response.status === 200 && response.data.status === 200) {
            this.tbl = response.data.data.tbl
            this.nla = response.data.data.nla
            resolve()
          } else reject(response.data.message)
        })
        .catch(err => {
          reject(err)
        })
    },
    get_data_registered(resolve, reject) {
      getData({ action: 8, tkn: this.$route.params.id, date: this.$route.params.time })
        .then(response => {
          if (response.status === 200 && response.data.status === 200) {
            this.formulario.preregistro = response.data.id
            this.formulario.persona = response.data.data
            this.formulario.dependencia = response.data.dependencia
            this.formulario.entidadFederativa = response.data.entidadFederativa
            this.especialidad = response.data.especialidad
            this.plan_estudios = response.data.plan
            resolve()
          } else {
            this.error_page = true
            this.loader.formulario = false
            this.$bvToast.toast(response.data.message, {
              title: `${response.data.status} - Error precargando datos`,
              variant: 'danger',
              solid: true,
            })
            reject(response.data.message)
          }
        })
        .catch(err => {
          this.$bvToast.toast(err, {
            title: 'Error en solicitud [precarga de datos]',
            variant: 'danger',
            solid: true,
          })
          reject(err)
        })
    },
    validacion_persona(resolve, reject) {
      const datos = {
        tkn: this.$route.params.id,
        date: this.$route.params.time,
      }
      getData({ action: 20, dato: datos })
        .then(response => {
          if (response.status === 200 && response.data.status === 200) {
            this.procede = true
            resolve()
          } else {
            this.error_page = true
            this.loader.formulario = false
            this.$bvToast.toast(`Este paso ya fue realizado: para -. ${response.data.data}`, {
              title: ' Error precargando datos',
              variant: 'danger',
              solid: true,
            })
            reject()
          }
        })
        .catch(() => {
          reject()
        })
    },
    get_departamentos() {
      getData({ action: 9 })
        .then(response => {
          if (response.status === 200 && response.data.status === 200) {
            this.departamentos = response.data.data
          } else {
            this.$bvToast.toast(response.data.message, {
              title: `${response.data.status} - Error cargando departamentos`,
              variant: 'danger',
              solid: true,
            })
          }
        })
        .catch(err => {
          this.$bvToast.toast(err, {
            title: 'Error en solicitud [departamentos]',
            variant: 'danger',
            solid: true,
          })
        })
    },
    get_puestos() {
      getData({ action: 10 })
        .then(response => {
          if (response.status === 200 && response.data.status === 200) {
            this.puestos = response.data.data
          } else {
            this.$bvToast.toast(response.data.message, {
              title: `${response.data.status} - Error cargando puestos`,
              variant: 'danger',
              solid: true,
            })
          }
        })
        .catch(err => {
          this.$bvToast.toast(err, {
            title: 'Error en solicitud [puestos]',
            variant: 'danger',
            solid: true,
          })
        })
    },
    get_grados() {
      getData({ action: 11 })
        .then(response => {
          if (response.status === 200 && response.data.status === 200) {
            this.grados = response.data.data
          } else {
            this.$bvToast.toast(response.data.message, {
              title: `${response.data.status} - Error cargando grados`,
              variant: 'danger',
              solid: true,
            })
          }
        })
        .catch(err => {
          this.$bvToast.toast(err, {
            title: 'Error en solicitud [grados]',
            variant: 'danger',
            solid: true,
          })
        })
    },
    get_tipo_admision() {
      getData({ action: 6 })
        .then(response => {
          if (response.status === 200 && response.data.status === 200) {
            this.admision = response.data.data
          } else {
            this.$bvToast.toast(response.data.message, {
              title: `${response.data.status} - Error cargando tipo de admisión`,
              variant: 'danger',
              solid: true,
            })
          }
        })
        .catch(err => {
          this.$bvToast.toast(err, {
            title: 'Error en solicitud [tipo de admisión]',
            variant: 'danger',
            solid: true,
          })
        })
    },
    get_ciclo_admision() {
      getData({ action: 7 })
        .then(response => {
          if (response.status === 200 && response.data.status === 200) {
            this.ciclo = response.data.data
          } else {
            this.$bvToast.toast(response.data.message, {
              title: `${response.data.status} - Error cargando tipo de admisión`,
              variant: 'danger',
              solid: true,
            })
          }
        })
        .catch(err => {
          this.$bvToast.toast(err, {
            title: 'Error en solicitud [tipo de admisión]',
            variant: 'danger',
            solid: true,
          })
        })
    },
    async get_available_files() {
      try {
        const { status, data } = await getData({ action: 36, q: this.plan_estudios.id })
        if (status !== 200 || data.status !== 200) {
          this.$bvToast.toast(data.message, {
            title: `${data.status} - Error cargando lista de archivos`,
            variant: 'danger',
            solid: true,
          })
          return
        }

        this.neededFiles = data.data
      } catch (error) {
        this.$bvToast.toast(error, {
          title: 'Error en solicitud [lista de archivos]',
          variant: 'danger',
          solid: true,
        })
      }
    },
    intervalRedirect() {
      interval = setInterval(() => {
        if (this.tbl === this.old_tbl) {
          this.$bvToast.toast('El formulario de pre-registro ha expirado, ingrese nuevamente', {
            title: 'Formulario caducado',
            variant: 'warning',
            solid: true,
          })
          clearInterval(interval)
          this.$router.push('/')
        }
        this.old_tbl = this.tbl
      }, 2700000)
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
